// extracted by mini-css-extract-plugin
module.exports = {"background":"ScreenPositionModal_background__3Ih98","container":"ScreenPositionModal_container__253-y"};